import { Component, type ReactNode } from 'react';

interface Props { children: ReactNode; }
interface State { hasError: boolean; }

class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 32, textAlign: 'center' }}>
          <i className="pi pi-exclamation-triangle" style={{ fontSize: 40, color: '#fde047', marginBottom: 16 }}></i>
          <h2 style={{ color: '#fff', fontSize: 20, fontWeight: 700, marginBottom: 8 }}>Etwas ist schiefgelaufen</h2>
          <p style={{ color: '#b8c4d0', fontSize: 14, marginBottom: 24 }}>Bitte laden Sie die Seite neu.</p>
          <button
            onClick={() => window.location.reload()}
            style={{ background: '#079ACD', color: '#fff', border: 'none', borderRadius: 999, padding: '10px 22px', fontFamily: 'Roboto, sans-serif', fontSize: 14, cursor: 'pointer' }}
          >
            Seite neu laden
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
